// extracted by mini-css-extract-plugin
export default {"productGallery":"XI-z","inQuickShop":"YI-z"};